import React, {useEffect, useState} from 'react';

import styles from './ChooseCityModal.module.css'

import {DesktopModal} from "../../../../ui/Modal/desktop/DesktopModal.tsx";
import {MobileModal} from "../../../../ui/Modal/mobile/MobileModal.tsx";
import {Input} from "../../../../ui/DataEntry/Input/Input.tsx";
import {cn} from "../../../../utils/cn.ts";
import {useScreenDetector} from "../../../../hooks/useScreenDetector.ts";
import {regularCities as cities} from "../../../../mock/cities.ts";
import {Icon} from "../../../../ui/General/Icon/Icon.tsx";
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {
    PickupPoint
} from "../../../Delivery/components/PickupPointModal/components/PickupPointList/PickupPointItem/types/PickupPoint.interface.ts";
import {changeCurrentBranch, changeCurrentTown} from "../../../../utils/changeLocation.ts";
// import { useMultiStorage } from '../../../../hooks/useStorage.ts';
import { API_URL } from '../../../../config.tsx';
import axios from 'axios';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setUserInfoField } from '@/utils/storage/slices/userSlice.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';

interface Props {
    isOpen: boolean,
    close: () => void
}

export const ChooseCityModal: React.FC<Props> = ({isOpen, close}) => {
    const { isMobile, isDesktop} = useScreenDetector()
    const dispatch = useAppDispatch();
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    const townId = useAppSelector((state: RootState) => state.user.userInfo?.townId);
    const [mainCities, setMainCities] = useState<PickupPoint[]>([])
    const [regularCities, setRegularCities] = useState(cities);
    const [searchTownName, setSearchTownName] = useState('');
    const [controllers, setControllers] = useState([]);
    // const [storage, setStorage] = useMultiStorage({
    //     townId: ['currentTownId', 1],
    //     branchId: ['currentBranchId', 1],
    //     getUserData: ['getUserData', false],
    //     getCartOffer: ['getCartOffer', false],
    //   });


    const handleAbort = () => {
        controllers.map(controller => {
            // @ts-ignore
            controller.abort();
        })
    }

    const getMainCities = () => {
        axios.get(`${API_URL}/branch_points`, {
            withCredentials: true,
        })
            .then(response => response.data)
            .then(data => setMainCities(data))
    }

    const findTown = (query: any) => {
        handleAbort();
        let newControllersList = controllers;
        const abortController = new AbortController();
        // @ts-ignore
        newControllersList.push(abortController);
        setControllers(newControllersList);
        axios.get(`${API_URL}/find_town?query=${query}`, {
            withCredentials: true,
            signal: abortController.signal
        })
            .then(response => response.data)
            .then(data => setRegularCities(data))
    }

    const getTownByIp = () => {
        axios.get(`${API_URL}/find_town_by_ip`, {
            withCredentials: true,
        })
            .then(response => response.data)
            .then(data => {
                if(data.name) {
                    changeSearchTownName(data.name);
                }
            })
    }

    const sortedRegularCities = (regularCities: { id: any; name: any; region: string; }[]) => {
        const sorted: {id: number, name: string, region: string}[] = [];
        const addedLetters = new Map<string, string>()

        regularCities.sort().forEach(({id, name, region}) => {
            // @ts-ignore
            const letter = name[0].toUpperCase();
            const regularCityCount = regularCities.length;

            if (!addedLetters.has(letter)) {
                addedLetters.set(letter, letter)

                sorted.push({id: Math.floor(Math.random() * 1000 + regularCityCount), name: letter, region})
            }

            sorted.push({id, name, region})
        })

        return sorted;
    }

    function splitIntoChunks<T>(array: T[], chunks: number): T[][] {
        const chunkSize = Math.ceil(array.length / chunks);
        return Array.from({length: chunks}, (_, i) =>
            array.slice(i * chunkSize, (i + 1) * chunkSize)
        );
    }

    const changeSearchTownName = (value: any) => {
        findTown(value);
        setSearchTownName(value);
    }

    const handleChangeCurrentBranch = (branchId: number) => {
        changeCurrentBranch(branchId);
        setTimeout(function () {
            dispatch(setUserInfoField({name: 'branchId', value: branchId}));
            dispatch(userInfoLoader());
            dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true}));
            // setStorage('branchId', branchId);
            // setStorage('getUserData', true);
            // setStorage('getCartOffer', true);
            close();
        }, 1000);
    }

    const handleChangeCurrentTown = (townId: number) => {
        changeCurrentTown(townId);
        setTimeout(function () {
            dispatch(setUserInfoField({name: 'townId', value: townId}));
            dispatch(userInfoLoader());
            dispatch(cartOfferLoader({cartId: cartId || 0, isMini: false, all: true}));
            // setStorage('townId', townId);
            // setStorage('getUserData', true);
            // setStorage('getCartOffer', true);
            close();
        }, 1000);
    }

    useEffect(() => {
        getMainCities();
        findTown('');
    }, []);

    return (<>
        {
            isDesktop ? (
            <DesktopModal isOpen={isOpen} close={close} title='выберите город'>
                <div style={{width: 600, padding: '24px 0',}}>
                    <div style={{display: 'flex',}}>
                        <Input
                            icon={<Icon name='search' width={18} height={18} color='#9a9a9a' />}
                            className={styles.input}
                            placeholder='Ваш город'
                            value={searchTownName}
                            hasBorder
                            changeStateValue={changeSearchTownName}
                        />
                        <Button
                            style={{display: 'flex', marginTop: 12, marginLeft: 24,}}
                            className={styles.btnFindCity}
                            type='text'
                            onClick={() => getTownByIp()}
                        >
                            <Icon name='arrow' width={14} height={14} color='#F59B28'/>
                            <div  style={{marginLeft: 12,fontSize: 13,}}>Определить автоматически</div>
                        </Button>
                    </div>
                </div>
            <div className={styles.cities}>
                {mainCities.length !== 0 && (<>
                    <ul className={styles.mainCities}>
                        {mainCities.filter(({townName}) => {
                                if(!searchTownName) return true;
                                return townName.toLowerCase().includes(searchTownName.toLowerCase());
                            }
                        ).map((point: PickupPoint) => (
                            <li key={point.townId} className={cn(styles.mainCity, styles.city)}
                                onClick={() => {handleChangeCurrentBranch(point.id);}}>
                                {townId === point.townId ? <span style={{color: '#F59B28'}}>{point.townName}</span> : point.townName}
                            </li>
                        ))}
                    </ul>
                    <div className={styles.outline}></div>
                </>)}
                {splitIntoChunks(sortedRegularCities(regularCities), Math.ceil(regularCities.length / 15)).map((cities) => (
                    <ul className={styles.regularCities}>{cities.map((city: {id: number, name: string, region: string}) =>
                        (<li key={city.id} className={cn(city.name.length === 1 && styles.letter || styles.city)} onClick={() => {handleChangeCurrentTown(city.id);close();}}>
                            {city.name}
                            <div>{city.region && city.name.length !== 1 ? <span>({city.region})</span> : ''}</div>
                        </li>))
                    }</ul>
                ))}
            </div>
        </DesktopModal>)
        : null}
        {isMobile ? (
            <MobileModal
                isOpen={isOpen}
                close={close}
                title={<h4 className={styles.title}>Выберите город</h4>}
            >
                <div className={styles.wrapper}>
                    <Input
                        icon={<Icon name='search' width={18} height={18} color='#9a9a9a' />}
                        className={styles.input}
                        hasBorder
                        placeholder='Ваш город'
                        value={searchTownName}
                        changeStateValue={changeSearchTownName}
                    />
                    <Button
                        className={styles.btnFindCity}
                        type='text'
                        onClick={() => getTownByIp()}
                    >
                        <Icon name='arrow' width={14} height={14} color='#F59B28' />
                        Определить автоматически
                    </Button>
                    <div className={styles.cities}>
                        <ul className={styles.regularCities}>{regularCities.filter(({name}) => {
                                if(!searchTownName) return true;
                                return name.toLowerCase().includes(searchTownName.toLowerCase());
                            }
                        ).map(({id, name}) =>
                            (<li key={id} className={cn(styles.city)}  onClick={() => {handleChangeCurrentTown(id);close();}}>{name}</li>))
                        }</ul>
                    </div>
                </div>
            </MobileModal>
        ): null}
    </>);
};
